import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getPracticeAdminHomePath, isPracticeAdmin } from '../../../utils/roleUtils';

/**
 * Prevents Practice Admins from accessing the global practices list or enrollment.
 */
const BlockGlobalPracticesRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  if (isPracticeAdmin(user)) {
    return <Navigate to={getPracticeAdminHomePath(user)} replace />;
  }

  return children;
};

export default BlockGlobalPracticesRoute;
